import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';
import { Navbar, NavbarProps } from './Navbar';

export function NavbarWrapper(props: Omit<NavbarProps, 'isDarkTheme'>) {
  const { theme } = useTheme();

  return <Navbar {...props} isDarkTheme={theme === Theme.DARK} />;
}
